import { gql } from '@apollo/client';

export const GET_ALL_FLYERS = gql`
query getAllFlyers($input: GetAllFlyersInput!) {
  getAllFlyers(input: $input) {
    items {
      flyerId
      startDate
      endDate
      submittedAt
      districtId
      title
      status
      frontImageUrl
      isFavorite
      isRead
      gradesOrAges
      criticalDate
      minTargetGradeOrAge
      maxTargetGradeOrAge
      type
      categories
      schoolCount
      org {
        name
      }
     email
     pages {
      imageUrl
      pageNumber
      ocrText
     }
    }
    pagination {
      pageSize
      pageNumber
      total
    }
    facets {
      categories {
        key
        count
      }
      gradesOrAges {
        key
        count
      }
    }
  }
}
`
